import { Icon, LatLngExpression, LeafletEventHandlerFnMap } from "leaflet";
import { Marker } from "react-leaflet";

import { CircleAnnotation } from "./CircleAnnotation";
import RectangleAnnotation from "./RectangleAnnotation";
import ArrowAnnotation from "./ArrowAnnotation";
import { Annotation, ArrowAnnotationType } from "../../../model/internal/annotation";

interface AnnotationAssetProps {
  annotation: Annotation;
  icon: Icon;
  draggable?: boolean;
  isDragging: boolean;
  arrowSnappingActive: boolean;
  easyClickTolerance: number;
  eventHandlers?: LeafletEventHandlerFnMap;
  highlighted: boolean;
}

const AnnotationAsset = ({
  annotation,
  icon,
  draggable,
  isDragging,
  arrowSnappingActive,
  easyClickTolerance,
  eventHandlers,
  highlighted,
}: AnnotationAssetProps) => {
  return (
    <>
      {annotation.styles.class === "sticky-note" && (
        <Marker
          key={annotation.id}
          position={annotation.geometry as LatLngExpression}
          icon={icon}
          draggable={draggable}
          eventHandlers={{
            ...eventHandlers,
            click: (e) => {
              if (arrowSnappingActive) {
                // Pass the click event to map so that Arrow Drawing tool will receive it it
                const map = e.target._map;
                const mouseLatLng = map.mouseEventToLatLng(e.originalEvent);
                map.fire("click", { latlng: mouseLatLng, originalEvent: e.originalEvent });
              } else {
                eventHandlers?.click?.(e);
              }
            },
          }}
        />
      )}
      {annotation.styles.class === "rectangle" && (
        <RectangleAnnotation
          rectangle={annotation}
          draggable={draggable}
          isDragging={isDragging}
          highlighted={highlighted}
          easyClickTolerance={easyClickTolerance}
          arrowSnappingActive={arrowSnappingActive}
          eventHandlers={eventHandlers}
        />
      )}
      {annotation.styles.class === "circle" && (
        <CircleAnnotation
          circle={annotation}
          highlighted={highlighted}
          arrowSnappingActive={arrowSnappingActive}
          easyClickTolerance={easyClickTolerance}
          eventHandlers={eventHandlers}
        />
      )}
      {annotation.styles.class === "arrow" && (
        <ArrowAnnotation
          arrow={annotation as ArrowAnnotationType}
          highlighted={highlighted}
          easyClickTolerance={easyClickTolerance}
          eventHandlers={eventHandlers}
        />
      )}
    </>
  );
};

export default AnnotationAsset;
